import request, { HttpMethod } from '@app/libs/request';
import { InfoResponse, ServerInfo } from '@app/domain/info';
import config, { serverUrl } from '@app/config';
import { cleanPathFromUrl } from '@app/utils/stringUtils';
import { isTruthy } from '@app/utils/utils';

export async function serverInfo(url: string, label: string): Promise<ServerInfo> {
  try {
    const info = await request<InfoResponse>(url, '/actuator/info', {
      method: HttpMethod.get,
      generateDynamicHeaders: false,
      dontRedirectToLogin: true,
      suppressNotification: true,
    });
    return {
      url,
      serverName: label,
      branch: info?.git?.branch,
      commitDate: info?.git?.commit?.time,
    };
  } catch (error: any) {
    return { url, serverName: label };
  }
}

function getAllServerUrls(): { url: string; label: string }[] {
  const mainUrl = cleanPathFromUrl(serverUrl);
  const knoxerUrls = config.knoxersAuthData.map((knoxer) => knoxer.url).filter(isTruthy);
  const firstKnoxerUrl = knoxerUrls[0];

  return [
    { url: mainUrl, label: 'Client' },
    { url: firstKnoxerUrl, label: 'Knoxers' },
  ];
}

export async function fetchAllServersInfo(): Promise<ServerInfo[]> {
  if (!config.runInfoCheck) {
    return [];
  }

  const urlObjs = getAllServerUrls();
  return Promise.all(urlObjs.map(({ url, label }) => serverInfo(url, label)));
}
